import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  searchOutlet,
  onClickCancelModal,
  selectAllOutlets,
  onClickAssignPromoModal,
  unselectAllOutlets,
} from 'actions/businessLibrary/promo/promo';
import { Link } from 'react-router';
import { Field, reduxForm, getFormValues, isPristine } from 'redux-form';
import { useMokaOutletPropsFirst } from 'utils/formatter';
import styles from './AssignPromoToOutletModal.css';

class AssignPromoToOutletModal extends React.Component {
  render() {
    const {
      showAssignOutletModal,
      outlets,
      formValues,
      isPristineForm,
    } = this.props;
    return (
      <Modal
        show={showAssignOutletModal}
        dialogClassName={styles['modal-dialog']}
      >
        <Modal.Header bsClass={`modal-header ${styles.header}`}>
          Assign Promo to Outlet
        </Modal.Header>
        <Modal.Body bsClass={`modal-body ${styles['modal-body']}`}>
          <div className={`col-md-12 ${styles.search}`}>
            <div className="right-inner-addon">
              <i className="fa fa-search" />
              <input
                className="form-control"
                placeholder="Search"
                onChange={this._onChange}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className={styles['title-fields']}>
              <span className={styles['lbl-selected-outlet']}>
                Select Outlet
              </span>
              <span className={styles['lbl-select-all']}>
                {formValues &&
                (this._shouldChangeLabelSelectAll(formValues) ||
                  !formValues.selectedOutlets.find(out => out.show)) ? (
                  <Link onClick={this._selectAllOutlets}>Select All</Link>
                ) : (
                  <Link onClick={this._unselectAllOutlets}>Unselect All</Link>
                )}
              </span>
            </div>
            <br />
            <ul>
              {outlets &&
                outlets.map((outlet, index) => {
                  return (
                    formValues &&
                    formValues.selectedOutlets.length > 0 &&
                    formValues.selectedOutlets[index] &&
                    formValues.selectedOutlets[index].show && (
                      <div className={styles['list-outlet']} key={index}>
                        <label
                          className={styles['outlet-name']}
                          htmlFor={`selectedOutlets[${index}].checked`}
                        >
                          {useMokaOutletPropsFirst(outlet, o => o.name)}
                        </label>
                        <Field
                          key={index}
                          name={`selectedOutlets[${index}].checked`}
                          type="checkbox"
                          component="input"
                          label={useMokaOutletPropsFirst(outlet, o => o.name)}
                          className="pull-right"
                          id={`selectedOutlets[${index}].checked`}
                        />
                        <br />
                      </div>
                    )
                  );
                })}
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <span className={styles['lbl-selected-outlet']}>
            Selected Outlet:{' '}
            {formValues &&
              this._countSelectedOutlet(formValues.selectedOutlets)}
          </span>
          <span className="pull-right">
            <button
              type="button"
              className="btn btn-default"
              onClick={this._onClickCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this._clickAssignPromo}
              disabled={
                isPristineForm ||
                this._countSelectedOutlet(formValues.selectedOutlets) === 0
              }
            >
              Assign Promo
            </button>
          </span>
        </Modal.Footer>
      </Modal>
    );
  }

  _onChange = event => {
    const { outlets } = this.props;
    const { value } = event.target;
    this.props.dispatch(searchOutlet(outlets, value));
  };

  _onClickCancel = () => {
    const { selectedOutlets, formValues } = this.props;
    this.props.dispatch(
      onClickCancelModal(selectedOutlets, formValues.selectedOutlets)
    );
  };

  _selectAllOutlets = () => {
    const { formValues } = this.props;
    this.props.dispatch(selectAllOutlets(formValues));
  };

  _unselectAllOutlets = () => {
    const { formValues } = this.props;
    this.props.dispatch(unselectAllOutlets(formValues));
  };

  _clickAssignPromo = () => {
    const { formValues } = this.props;
    this.props.dispatch(onClickAssignPromoModal(formValues));
  };

  _countSelectedOutlet = selectedOutlets => {
    let counter = 0;
    for (let idx = 0; idx < selectedOutlets.length; idx++) {
      if (selectedOutlets[idx] && selectedOutlets[idx].checked) {
        counter++;
      }
    }
    return counter;
  };

  _shouldChangeLabelSelectAll = formValues => {
    let idx = 0;
    let foundNotChecked = false;
    while (idx < formValues.selectedOutlets.length) {
      if (
        formValues.selectedOutlets[idx] &&
        formValues.selectedOutlets[idx].show &&
        !formValues.selectedOutlets[idx].checked
      ) {
        foundNotChecked = true;
        break;
      }
      idx++;
    }
    return foundNotChecked;
  };
}

const mapForm = {
  form: 'promoAssignOutlet',
};

function mapStateToProps(state) {
  const {
    showAssignOutletModal,
    outlets,
    selectedOutlets,
  } = state.businessLibrary.promo;
  return {
    showAssignOutletModal,
    outlets,
    formValues: getFormValues('promoAssignOutlet')(state),
    isPristineForm: isPristine('promoAssignOutlet')(state),
    selectedOutlets,
  };
}
export default connect(mapStateToProps)(
  reduxForm(mapForm)(AssignPromoToOutletModal)
);
